export const prepareBookingForDuplication = (data) => {
  const isDuplicate = !!data.isDuplicate;
  delete data.isDuplicate;
  if (isDuplicate) {
    delete data.dateFrom;
    delete data.dateTo;
    data.bookingEntries?.forEach((entry) => {
      delete entry.bookedSlots;
      delete entry.allDay;
    });
  }
  return isDuplicate;
};

export const hazardousStatusGetter = (params) => {
  const status = params?.data?.approval?.status || params?.data?.hazardousStatus;
  return status?.toString().toUpperCase() || 'N/A';
}

/**
 * Converts any value to a boolean by first coercing to a number.
 * Useful for converting numeric strings or database flags (0/1) to boolean.
 * @param {any} value - The value to convert to boolean
 * @returns {boolean} - True if the numeric value is truthy, false otherwise
 * @example
 * convertNumericValueToBoolean('1') // true
 * convertNumericValueToBoolean('0') // false
 * convertNumericValueToBoolean(1) // true
 * convertNumericValueToBoolean(null) // false
 */
export const convertNumericValueToBoolean = (value) => !!+value;
